module.exports = __webpack_public_path__ + "media/images/icons/outlined/split-cells-da5e2422cf23a1b51d60c06dab5d7f20.svg";